import React from 'react';

/**
 * Brand · Model · Processor · Generation · RAM · Hard disk (23 Oct 2026).
 * One row of compact dropdowns, each listing what is left under the other
 * filters with counts; a picked one is highlighted and Clear resets all.
 * Used by Ready stock (counts worked out in the browser), Assets and the floor
 * board (counts from the server).
 *
 * facets: { brand: [[value, count], …], … }   value: { brand: 'Dell', … }
 */
export const CONFIG_KEYS = [
  { key: 'brand', label: 'Brand' },
  { key: 'model', label: 'Model' },
  { key: 'processor', label: 'Processor' },
  { key: 'generation', label: 'Generation' },
  { key: 'ram', label: 'RAM' },
  { key: 'storage', label: 'Hard disk' },
];

/** { brand: 'Dell' } → { cfg_brand: 'Dell' } for a list API. */
export const cfgParams = (value) => Object.fromEntries(Object.entries(value || {}).filter(([, v]) => v).map(([k, v]) => [`cfg_${k}`, v]));

export default function ConfigFilters({ facets = {}, value = {}, onChange, count = null, unit = 'laptop' }) {
  const on = CONFIG_KEYS.some((f) => value[f.key]);
  return (
    <div className="c-cfg-filters" role="group" aria-label="Configuration">
      {CONFIG_KEYS.map((f) => {
        const opts = facets[f.key] || [];
        const picked = value[f.key];
        return (
          <label key={f.key} className={`c-cfg-f${picked ? ' is-set' : ''}`}>
            <span>{f.label}</span>
            <select className="c-input" value={picked || ''} onChange={(e) => onChange({ ...value, [f.key]: e.target.value || undefined })}>
              <option value="">All</option>
              {opts.map(([v, n]) => <option key={v} value={v}>{v} ({n})</option>)}
              {picked && !opts.some(([v]) => v === picked) && <option value={picked}>{picked} (0)</option>}
            </select>
          </label>
        );
      })}
      {on && <button type="button" className="c-q-clear" onClick={() => onChange({})}>Clear</button>}
      {count != null && <span className="c-cfg-count">{count.toLocaleString('en-IN')} {unit}{count === 1 ? '' : 's'}</span>}
    </div>
  );
}
